export interface Button {
    id: ID;
    type: ButtonType;
    name: string;
    archivedAt: string;
    archivedBy: { id: ID };
    items: ButtonItem[];
    autoApplyCode: string | null;
    object: "button";
}

export interface ButtonItem {
    object: string;
    product: {
        id: string;
    };
    sequence: number;
}

export enum ButtonType {
    CHECKOUT = "checkout",
    GIFT = "gift",
    SINGLE = "single",
    TIMELINE = "timeline",
    DAY = "day",
    ALL_PRODUCTS = "all_products",
}

export enum ButtonObjectType {
    EXPERIENCE = "experience_button_item",
    GIFT_OFFER = "gift_offer_button_item",
    PACKAGE = "package_button_item",
    MEMBERSHIP = "membership_button_item",
    PARTNER_PACKAGE = "partner_package_button_item",
    WARE = "ware_button_item",
    COLLECTION = "collection_button_item",
}
